// src/utils/socketClient.js
import { io } from "socket.io-client";
import key from "../config";

let socket;

export const initSocket = () => {
  if (!socket) {
    socket = io(key.BACKEND_URL, {
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("✅ Connected to WebSocket");
      socket.emit("joinRoom", "trendingRoom");
    });

    socket.on("disconnect", (reason) => {
      console.warn("❌ Socket disconnected:", reason);
    });

    socket.on("reconnect", (attempt) => {
      console.log("🔁 Reconnected after", attempt, "attempts");
      socket.emit("joinRoom", "trendingRoom"); // Rejoin after reconnect
    });

    socket.on("connect_error", (err) => {
      console.error("⚠️ WebSocket connection error:", err.message);
    });
  }

  return socket;
};
